export default __webpack_public_path__ + "static/media/playmateImage.d8fc9891.jpg";